import { render, staticRenderFns } from "./OrticTable.vue?vue&type=template&id=4c7128ff&"
import script from "./OrticTable.vue?vue&type=script&lang=js&"
export * from "./OrticTable.vue?vue&type=script&lang=js&"
import style0 from "./OrticTable.vue?vue&type=style&index=0&id=4c7128ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports